/**
 * Log in a user
 * @param {string} API_BASE 
 * @param {string} email 
 * @param {string} password 
 */
const LoginUser = async (API_BASE, email, password) => {
    try {
        const response = await fetch(`${API_BASE}/users/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                Email: email,
                Password: password
            })
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data; // Expected to contain name, role, token, code_etablissement, etc.
    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
};

export default LoginUser;
